<template>
    <div>
        <template v-if="footer.tipo == 1">
            <LayoutSports/>
        </template>
        <template v-if="footer.tipo == 2">
            <LayoutTeatros/>
        </template>
    </div>
</template>

<script>
    import LayoutSports from './layouts/Sports';
    import LayoutTeatros from './layouts/Teatros';

    export default {
        components: {
            LayoutSports,
            LayoutTeatros
        },
        head: {
            title: function() {
                return {
                    inner: 'Simpatizantes',
                    complement: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title
                }                         
            },
            meta: function() {
                return [
                    {name: 'application-name', content: this.teatro.meta_title ? this.teatro.meta_title : this.configuracion.title + ' - Venta Oficial de entradas'},
                    {name: 'description', content: this.teatro.meta_description ? this.teatro.meta_description : 'Compra tus entradas en el punto oficial de venta en tan sólo 2 minutos. Venta oficial de entradas. Mejor precio garantizado. Compralaentrada', id: 'desc'}
                ]                
            },
        },
        computed : {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        created() {
            if(!this.footer.venta_simpatizantes) {
                this.$router.push({ name: 'front.home'});
            }
        }
    }
</script>
